const activeMobileClass = 'header-mobile-nav-active';
const headerMenuToggleClass = '.header-menu-toggle';
const headerMenuActiveClass = 'header-menu-toggle--is-active';
const headerMenuToggle = document.querySelector(headerMenuToggleClass);
const headerMenuItems = document.querySelectorAll('.header-mobile-nav-menu .menu-item');
// Get the header element
const header = document.querySelector('.header');
let lastScrollTop = 0;
const scrollThreshold = 5;

/**
 * Close the menu by removing active classes
 */
function closeMenu() {
	document.body.classList.remove(activeMobileClass);
	if (headerMenuToggle) {
		headerMenuToggle.classList.remove(headerMenuActiveClass);
	}
}

/**
 * Check and remove active mobile menu class on window resize
 * When window is larger than 768
 */
function checkAndRemoveActiveMobileClass() {
	if (window.innerWidth >= 768 && document.body.classList.contains(activeMobileClass)) {
		closeMenu();
	}
}

/**
 * Toggle the menu
 */
function toggleMenu() {
	function menuClickHandler() {
		headerMenuToggle.classList.toggle(headerMenuActiveClass);
		document.body.classList.toggle(activeMobileClass);
		checkAndRemoveActiveMobileClass();
	}

	if (headerMenuToggle) {
		headerMenuToggle.addEventListener('click', menuClickHandler);
	}

	// Add event listener for window resize
	window.addEventListener('resize', checkAndRemoveActiveMobileClass);
}

/**
 * Close the menu on menu item click
 */
if (headerMenuItems.length > 0) {
	headerMenuItems.forEach((item) => {
		item.addEventListener('click', () => {
			closeMenu();
		});
	});
}

/**
 * Close the menu on esc key
 */
document.addEventListener('keydown', (event) => {
	if (event.key === 'Escape') {
		closeMenu();
	}
});

/**
 * Hide header on scroll down and show on scroll up
 */
window.addEventListener('scroll', () => {
	// Get current scroll position
	const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

	// Don't do anything if scroll position hasn't changed much
	if (Math.abs(currentScrollTop - lastScrollTop) < scrollThreshold) {
		return;
	}

	// Check if user is scrolling down or up
	if (currentScrollTop > lastScrollTop && currentScrollTop > 100) {
		header.classList.add('hidden');
	} else {
		header.classList.remove('hidden');
	}

	lastScrollTop = currentScrollTop;
});

// Toggle main nav
toggleMenu();
